(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dcc-event-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dcc-event-gallery')) {
    class DccEventGallery extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.dcc-eg__lightbox');
        if (!this.dialog) return; // lightbox disabled in this instance

        this.dialogImg     = this.dialog.querySelector('.dcc-eg__lightbox-img');
        this.dialogCounter = this.dialog.querySelector('.dcc-eg__lightbox-counter');
        this.btnClose      = this.dialog.querySelector('.dcc-eg__lightbox-close');
        this.btnPrev       = this.dialog.querySelector('.dcc-eg__lightbox-prev');
        this.btnNext       = this.dialog.querySelector('.dcc-eg__lightbox-next');
        this.thumbs        = Array.from(this.querySelectorAll('button.dcc-eg__item'));
        this.currentIndex  = 0;

        if (this.thumbs.length <= 1) {
          this.dialog.classList.add('dcc-eg__lightbox--single');
        }

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', (e) => {
            e.preventDefault();
            const idx = parseInt(thumb.dataset.index, 10) || 0;
            this.open(idx);
          });
        });

        this.btnClose.addEventListener('click', () => this.dialog.close());

        if (this.btnPrev) this.btnPrev.addEventListener('click', () => this.navigate(-1));
        if (this.btnNext) this.btnNext.addEventListener('click', () => this.navigate(1));

        // Click backdrop (outside <img>) to close
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.dialog.close();
        });

        // Keyboard nav while dialog is open
        this.dialog.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft')  this.navigate(-1);
          if (e.key === 'ArrowRight') this.navigate(1);
        });
      }

      open(index) {
        this.currentIndex = index;
        this.updateImage();
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          // Fallback for browsers without <dialog> support
          this.dialog.setAttribute('open', '');
        }
      }

      navigate(direction) {
        const total = this.thumbs.length;
        if (total === 0) return;
        this.currentIndex = (this.currentIndex + direction + total) % total;
        this.updateImage();
      }

      updateImage() {
        const thumb = this.thumbs[this.currentIndex];
        if (!thumb) return;
        const fullSrc = thumb.dataset.fullSrc;
        const alt     = thumb.dataset.alt || '';
        this.dialogImg.src = fullSrc;
        this.dialogImg.alt = alt;
        if (this.dialogCounter) {
          this.dialogCounter.textContent = (this.currentIndex + 1) + ' / ' + this.thumbs.length;
        }
      }
    }
    customElements.define('dcc-event-gallery', DccEventGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dcc-event-intro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad2(n) { n = Number(n); return n < 10 ? '0' + n : String(n); }

    function tick(el) {
      var target = el._target;
      if (!target) return;

      var diff = target - Date.now();
      if (diff <= 0) {
        el.classList.add('dcc-event-intro__countdown--finished');
        if (el._timer) clearInterval(el._timer);
        return;
      }

      var days  = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins  = Math.floor((diff % 3600000) / 60000);
      var secs  = Math.floor((diff % 60000) / 1000);

      var nums = el._nums;
      if (nums.days)  nums.days.textContent  = days;
      if (nums.hours) nums.hours.textContent = pad2(hours);
      if (nums.mins)  nums.mins.textContent  = pad2(mins);
      if (nums.secs)  nums.secs.textContent  = pad2(secs);
    }

    function init() {
      var countdowns = document.querySelectorAll('.dcc-event-intro__countdown[data-event-time]');
      countdowns.forEach(function (el) {
        if (el._initialized) return;
        el._initialized = true;

        var target = new Date(el.dataset.eventTime).getTime();
        if (isNaN(target)) return;

        el._target = target;
        el._nums = {
          days:  el.querySelector('[data-unit="days"]'),
          hours: el.querySelector('[data-unit="hours"]'),
          mins:  el.querySelector('[data-unit="mins"]'),
          secs:  el.querySelector('[data-unit="secs"]')
        };

        tick(el);
        el._timer = setInterval(function () { tick(el); }, 1000);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-init when this section is re-rendered in the theme editor
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
